import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Grid, IconButton, Snackbar } from '@material-ui/core';
import { logException } from '../../services/appInsights';
import { callApi } from '../../util/apiWrapper';
import { fetchWorkbookModules } from '../../utils/fetchWorkbookModules';
import HelpDialog from '../Help/HelpDialog';
import LifeSkillsDialog from './SeniorListDialogs/LifeSkillsDialog';
import BoysTownLogo from '../../assets/img/bt.jpg';
import Home from './SeniorPlannerComponents/Home';
import HelpApps from './SeniorPlannerComponents/HelpApps';
import AftercareApps from './SeniorPlannerComponents/AftercareApps';
import ScholarshipApps from './SeniorPlannerComponents/ScholarshipApps';
import Recommendations from './SeniorPlannerComponents/Recommendations';
import BasicInfo from './SeniorPlannerComponents/BasicInfo';
import HelpApp from './SeniorPlannerComponents/HelpApp';
import Planning1 from './SeniorPlannerComponents/Planning1';
import Planning2 from './SeniorPlannerComponents/Planning2';
import SeniorChecklist from './SeniorPlannerComponents/Checklist';
import Aftercare from './SeniorPlannerComponents/Aftercare';
import Scholarship from './SeniorPlannerComponents/Scholarship';
import Recommendation from './SeniorPlannerComponents/Recommendation';
import Workbook from './SeniorPlannerComponents/Workbook.jsx';
import WorkbookModule from './SeniorPlannerComponents/WorkbookModule.jsx';
import Life from './SeniorPlannerComponents/Life';
import CloseIcon from '@material-ui/icons/Close';
import useAuthRedirect from '../../hooks/authRedirectHook';
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined';
import PlayPauseIcon from '../../assets/img/icons/pauseplay.svg';
import LockIcon from '../../assets/img/icons/lock.svg';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import useStyles from './SeniorPlanner.styles';
import { CONTENT_TYPE, METHOD } from '../../constants/method';
import PATH from '../../constants/paths';
import PleaseWait from '../Shared/PleaseWait';
import { displayStatus, formatPhoneNumber, isAdmin, isAlumni, isFHT, isStudent } from '../../util/miscUtil';

const SeniorPlanner = inject(
  'SeniorStore',
  'AuthStore',
  'eLearningStore'
)(
  observer((props) => {
    const store = props.SeniorStore;
    const auth = props.AuthStore;
    const eLearningStore = props.eLearningStore;
    const classes = useStyles();
    const history = useHistory();

    const [year, setYear] = useState('');
    const [page, setPage] = useState('home');
    const [showHelp, setShowHelp] = useState(false);
    const [showLifeSkills, setShowLifeSkills] = useState(false);
    const [showReturnedChecklist, setShowReturnedChecklist] = useState(false);
    const [showReturnedPlanningForm1, setShowReturnedPlanningForm1] = useState(false);
    const [showReturnedPlanningForm2, setShowReturnedPlanningForm2] = useState(false);
    const [checklistStatus, setChecklistStatus] = useState('');
    const [planningForm1Status, setPlanningForm1Status] = useState('');
    const [planningForm2Status, setPlanningForm2Status] = useState('');
    const [showReturnedAftercareApp, setShowReturnedAftercareApp] = useState(false);
    const [showReturnedScholarshipApp, setShowReturnedScholarshipApp] = useState(false);
    const [aftercareSpecialist, setAftercareSpecialist] = useState(null);
    const [warning, setWarning] = useState('');
    const [showWarning, setShowWarning] = useState(false);
    const [featureSwitches, setFeatureSwitches] = useState([]);

    const [workbookModuleList, setWorkbookModuleList] = useState([]);
    const [workbookModuleNumber, setWorkbookModuleNumber] = useState(0);
    const [workbookModuleId, setWorkbookModuleId] = useState(0);
    const [workbookModule, setWorkbookModule] = useState({});
    const [moduleCourseList, setModuleCourseList] = useState([]);
    const [allResources, setAllResources] = useState([]);

    useEffect(() => {
      window.scrollTo({ top: 0 });
      setYear(new Date().getFullYear());
    }, []);

    // Redirect user to login page if token is no longer available.
    useAuthRedirect(auth);
    const fetchWorkbook = async () => {
      try {
        let modulelist = [];
        const workbookModules = await callApi(auth, PATH.SENIOR_PLAN_DETAILS(store.senior.userId), METHOD.GET, null, CONTENT_TYPE.APPLICATION_JSON);
        if (workbookModules.result) {
          workbookModules.result.forEach((w) => {
            w.modules.forEach((m) => {
              modulelist.push(m);
            });
          });
          setWorkbookModuleList(modulelist);

          let resources = await callApi(auth, 'module/resource', 'GET');
          setAllResources(resources.result);
        }
      } catch (err) {
        logException(err);
        console.error(err);
      }
    };

    useEffect(() => {
      let checklistdata = {};
      let form1data = {};
      let form2data = {};

      async function fetchFeatureSwitchList() {
        if (featureSwitches.length === 0) {
          try {
            const fs = await callApi(auth, 'featureswitch', 'GET');
            const featureSwitchList = fs.result;
            setFeatureSwitches(featureSwitchList);
          } catch (error) {
            logException(error);
            console.warn('Error fetching feature switch list:', error);
          }
        }
      }

      const fetchAftercareSpecialistList = async () => {
        try {
          const specialists = await callApi(auth, 'staff', 'GET');
          store.setAftercareSpecialistList(
            specialists.result.filter(
              (s) =>
                s.is_active &&
                (s.position_class === '1347' || s.position_class === '2001' || s.position_class === '2148' || s.position_class === '1534')
            )
          );

          if (store.senior && store.senior.id > 0) {
            if (store.senior.aftercare_specialist > 0) {
              const spec = store.aftercareSpecialistList.find((s) => s.id === store.senior.aftercare_specialist);
              if (spec) {
                setAftercareSpecialist(spec);
                if (store.senior.aftercareSpecialistInfo?.id !== spec.id) {
                  store.setSenior({ ...store.senior, aftercareSpecialistInfo: spec });
                }
              } else {
                setAftercareSpecialist(null);
                if (store.senior.aftercareSpecialistInfo) {
                  store.setSenior({ ...store.senior, aftercareSpecialistInfo: null });
                }
                if (isAdmin(auth.roles)) {
                  setWarning('The assigned Successful Futures Specialist was not found. Please assign a valid specialist.');
                  setShowWarning(true);
                }
              }
            } else {
              setAftercareSpecialist(null);
              if (store.senior.aftercareSpecialistInfo) {
                store.setSenior({ ...store.senior, aftercareSpecialistInfo: null });
              }
              if (isAdmin(auth.roles)) {
                setWarning('No Successful Futures Specialist has been assigned. Please assign a valid specialist.');
                setShowWarning(true);
              }
            }
          }
        } catch (error) {
          console.warn('Error fetching aftercare specialist list from SeniorPlanner:', error);
          logException(error);
        }
      };

      async function fetchScholarshipApps(userId) {
        try {
          let scholarshipApps = await callApi(auth, 'scholarship/list/' + userId, 'GET');
          store.setScholarshipList(scholarshipApps.result);
          scholarshipApps.result.forEach((app) => {
            if (app.status === 'returned') {
              if (showReturnedScholarshipApp === false) {
                setShowReturnedScholarshipApp(true);
              }
            }
          });
        } catch (error) {
          console.error('Error fetching scholarship apps:', error);
          logException(error);
        }
      }

      async function fetchAftercareApps(userId) {
        try {
          let applications = await callApi(auth, 'aftercare/list/' + userId, 'GET');
          store.setAftercareList(applications.result);
          applications.result.forEach((app) => {
            if (app.status === 'returned') {
              setShowReturnedAftercareApp(true);
            }
          });
        } catch (error) {
          console.error('Error fetching aftercare apps:', error);
          logException(error);
        }
      }

      async function fetchChecklist(id) {
        try {
          const checklist = await callApi(auth, 'checklist/' + id, 'GET');
          if (checklist.result) {
            setShowReturnedChecklist(false);
            store.setChecklistObj(checklist.result);
            checklistdata = JSON.parse(checklist.result.checklist_data);
            const status = checklistdata.status;
            setChecklistStatus(status);
            if (status === 'returned') {
              setShowReturnedChecklist(true);
            }
          }
        } catch (error) {
          console.error('Error fetching checklist:', error);
          logException(error);
        }
      }

      async function fetchPlanningForm1(id) {
        try {
          const planningform1 = await callApi(auth, 'planningform1/' + store.senior.id, 'GET');
          if (planningform1.result) {
            setShowReturnedPlanningForm1(false);
            store.setPlanform1Obj(planningform1.result);
            form1data = JSON.parse(planningform1.result.planning_form_1_data);
            const status = form1data.status;
            setPlanningForm1Status(status);
            if (status === 'returned') {
              setShowReturnedPlanningForm1(true);
            }
          }
        } catch (error) {
          console.error('Error fetching planning form 1:', error);
          logException(error);
        }
      }

      async function fetchPlanningForm2(id) {
        try {
          const planningform2 = await callApi(auth, 'planningform2/' + store.senior.id, 'GET');
          if (planningform2.result) {
            setShowReturnedPlanningForm2(false);
            store.setPlanform2Obj(planningform2.result);
            form2data = JSON.parse(planningform2.result.planning_form_2_data);
            const status = form2data.status;
            setPlanningForm2Status(status);
            if (status === 'returned') {
              setShowReturnedPlanningForm2(true);
            }
          }
        } catch (error) {
          console.error('Error fetching planning form 2:', error);
          logException(error);
        }
      }

      async function fetchSenior() {
        try {
          if (!store.senior || (store.senior && Object.keys(store.senior).length === 0)) {
            let senior = {};

            if (store.basicInfoId > 0) {
              senior = await callApi(auth, 'student/' + store.basicInfoId, 'GET');
            } else if (auth && auth.user && auth.user.result) {
              senior = await callApi(auth, 'studentplan/' + auth.user.result.id, 'GET');
            }
            if (senior.result) {
              const specialistInfo = store.aftercareSpecialistList.find((s) => s.id === senior.result.aftercare_specialist) || null;
              if (specialistInfo) {
                senior.result.aftercareSpecialistInfo = specialistInfo;
                setAftercareSpecialist(specialistInfo);
              } else {
                setAftercareSpecialist(null);
              }
              store.setSenior(senior.result);
            }
          }
        } catch (error) {
          console.error('Error fetching senior:', error);
          logException(error);
        }
      }

      store.setLoading(true);
      store.setSearching(true);

      fetchFeatureSwitchList();
      fetchAftercareSpecialistList();
      fetchSenior();

      if (store.senior && Object.keys(store.senior).length > 0) {
        fetchWorkbook(store.senior.id);
        fetchChecklist(store.senior.id);
        fetchPlanningForm1(store.senior.id);
        fetchPlanningForm2(store.senior.id);
        fetchAftercareApps(store.senior.userId);
        fetchScholarshipApps(store.senior.userId);

        const thisSenior = store.senior;
        thisSenior.checklist = checklistdata;
        thisSenior.planning_form_1 = form1data;
        thisSenior.planning_form_2 = form2data;
        store.setSenior(thisSenior);
        eLearningStore.loadState(thisSenior);
      }
      store.setLoading(false);
      store.setSearching(false);
    }, [store, auth, store.senior, auth.user]);

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setShowWarning(false);
    };

    const handleReturnToSeniorList = () => {
      store.setSenior(null);
      if (store.alumni) {
        history.push('/alumnilist');
      } else {
        if (isFHT(auth.roles)) {
          history.push('/familyhomelist');
        } else {
          history.push('/seniorlist');
        }
      }
    };

    const handleAfterSaveReturn = () => {
      setShowReturnedAftercareApp(false);
      window.scrollTo(0, 0);
      store.aftercareList.forEach((app) => {
        if (app.status === 'returned') {
          setShowReturnedAftercareApp(true);
        }
      });

      let tempShowReturnedScholarshipApp = false;
      store.scholarshipList.forEach((app) => {
        if (app.status === 'returned') {
          tempShowReturnedScholarshipApp = true;
        }
      });
      setShowReturnedScholarshipApp(tempShowReturnedScholarshipApp);

      setShowReturnedChecklist(false);
      if (checklistStatus === 'returned') {
        setShowReturnedChecklist(true);
      }

      setShowReturnedPlanningForm1(false);
      if (planningForm1Status === 'returned') {
        setShowReturnedPlanningForm1(true);
      }

      setShowReturnedPlanningForm2(false);
      if (planningForm2Status === 'reopened') {
        setShowReturnedPlanningForm2(true);
      }

      setPage('home');
    };

    const handleAfterAboutMeUpdate = (newSeniorData) => {
      store.setSenior(newSeniorData);
      setPage('recommendationpage');
    };

    const handleGotoAdminHomepage = () => {
      history.push('/');
    };

    const action = (
      <React.Fragment>
        <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
          <CloseIcon fontSize='small' />
        </IconButton>
      </React.Fragment>
    );

    const openAftercareApp = async (id) => {
      store.setAftercareAppId(id);
      try {
        store.setLoading(true);
        store.setSearching(true);
        let application = await callApi(auth, 'aftercare/' + id, 'GET');
        if (application.result) store.setAftercareApp(application.result);
        store.setSearching(false);
        store.setLoading(false);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error fetching senior:', error);
      }
      setPage('aftercareapp');
    };

    const handleCreateAftercareApp = async () => {
      store.setAppCreated(true);
      try {
        store.setLoading(false);
        store.setSearching(true);
        const app = await callApi(auth, 'aftercare', 'POST', {
          item: {
            userId: store.senior.userId,
            status: 'created',
            status_date: new Date(),
            status_by: auth.user.result.first_name + ' ' + auth.user.result.last_name,
            version: 2,
          },
        });

        if (app.result) {
          store.setAftercareApp(app.result);
          store.setAftercareAppId(app.result.id);
        }
        store.setSearching(false);
        store.setLoading(false);
        openAftercareApp(app.result.id);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error writing updated Successful Futures application:', error);
      }
    };

    const fetchAftercareApplications = async () => {
      try {
        store.setLoading(true);
        store.setSearching(true);
        let applications = await callApi(auth, 'aftercare/list/' + store.senior.userId, 'GET');
        if (applications.result) store.setAftercareList(applications.result);
        store.setSearching(false);
        store.setLoading(false);
        setPage('aftercareapps');
      } catch (err) {
        console.error(err);
        return Promise.reject(err);
      }
    };

    const openScholarshipApp = async (id) => {
      store.setScholarshipAppId(id);
      try {
        store.setLoading(true);
        store.setSearching(true);
        let scholarship = store.scholarshipList.find((s) => s.id === id);
        store.setScholarshipApp(scholarship);
        store.setSearching(false);
        store.setLoading(false);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error locating scholarship app:', error);
      }
      setPage('scholarshipapp');
    };

    const openWorkbookModule = async (id, number) => {
      try {
        store.setLoading(true);
        store.setSearching(true);

        let coursesToDisplay = [];

        setWorkbookModuleId(id);
        setWorkbookModuleNumber(number);

        let module = workbookModuleList.find((m) => m.id === id);

        if (module) {
          setWorkbookModule(module);

          //Steps (Not displayed)
          module.steps.forEach((step) => {
            //Courses
            step.courses.forEach((course) => {
              coursesToDisplay.push(course);
            });
          });

          // Setting list of Courses for Module Page
          if (coursesToDisplay.length > 0) {
            setModuleCourseList(coursesToDisplay);
          }
        }
        store.setSearching(false);
        store.setLoading(false);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error locating workbook module:', error);
      }
      setPage('workbookmodule');
    };

    const openRecommendation = async (id) => {
      store.setRecommendationId(id);
      try {
        store.setLoading(true);
        store.setSearching(true);
        let recommendations = await callApi(auth, 'recommendation/student/' + store.senior.id, 'GET');
        if (recommendations.result) {
          let letter = recommendations.result.find((s) => s.recommendation_id === id);
          store.setRecommendation(letter);
        }
        store.setSearching(false);
        store.setLoading(false);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error locating letter of recommendation request:', error);
      }
      setPage('recommendationpage');
    };

    const openHelpApp = async (id) => {
      store.setHelpAppId(id);
      try {
        store.setLoading(true);
        store.setSearching(true);
        let app = store.helpAppList.find((s) => s.id === id);
        store.setHelpApp(app);
        store.setSearching(false);
        store.setLoading(false);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error locating help request app:', error);
      }
      setPage('helpapp');
    };

    const summarizeHelpOptions = (app) => {
      if (!app || (app && app.length === 0)) return [];
      let list = [];
      const appValues = JSON.parse(app);
      if (appValues.coaching) {
        list.push('Coaching');
      }
      if (appValues.dailyLiving) {
        list.push('Daily Living');
      }
      if (appValues.education) {
        list.push('Education');
      }
      if (appValues.employment) {
        list.push('Employment');
      }
      if (appValues.finances) {
        list.push('Finances');
      }
      if (appValues.food) {
        list.push('Food');
      }
      if (appValues.health) {
        list.push('Health');
      }
      if (appValues.housing) {
        list.push('Housing');
      }
      if (appValues.legalDocs) {
        list.push('Legal Documents');
      }
      if (appValues.lifeSkills) {
        list.push('Life Skills');
      }
      if (appValues.mentalHealth) {
        list.push('Mental Health');
      }
      if (appValues.scholarships) {
        list.push('Scholarships');
      }
      if (appValues.transportation) {
        list.push('Transportation');
      }
      if (appValues.utilities) {
        list.push('Utilities');
      }
      if (appValues.other) {
        list.push('Other');
      }
      return list;
    };

    const handleSetButtonColorByStatus = (status) => {
      switch (status) {
        case 'started':
          return 'secondary';
        case 'completed':
          return 'success';
        default:
          return 'lightblue';
      }
    };

    const handleSetButtonColorByRegisteredCompletion = (course) => {
      if (isPreviousCourseComplete(course, course.registered, course.completed)) {
        if (course.completed) {
          return 'success';
        } else if (course.registered) {
          return 'secondary';
        } else {
          return 'lightblue';
        }
      } else {
        return 'default';
      }
    };

    const fetchButtonCompletionStatus = (status) => {
      if (status === 'notstarted') {
        return (
          <div className={classes.alignButtonText}>
            <PlayCircleOutlineOutlinedIcon className={classes.statusIconAndText} />{' '}
            {isAdmin(auth.roles) ? (
              <span className={classes.statusIconAndText}>View</span>
            ) : (
              <span className={classes.statusIconAndText}>Get Started</span>
            )}
          </div>
        );
      } else if (status === 'completed') {
        return (
          <div className={classes.alignButtonText}>
            <CheckBoxIcon className={classes.statusIconAndText} />{' '}
            {isAdmin(auth.roles) ? (
              <span className={classes.statusIconAndText}>View</span>
            ) : (
              <span className={classes.statusIconAndText}>Completed</span>
            )}
          </div>
        );
      } else if (status === 'started') {
        return (
          <div className={classes.alignButtonText}>
            <img src={PlayPauseIcon} alt='Continue' className={classes.statusIconColor} height={18} />{' '}
            {isAdmin(auth.roles) ? <span className={classes.statusTextColor}>View</span> : <span className={classes.statusTextColor}>Continue</span>}
          </div>
        );
      }
    };

    const fetchModuleCompletionStatus = (status) => {
      if (status === 'started') {
        return (
          <div className={classes.alignButtonText}>
            <img src={PlayPauseIcon} alt='Continue' className={classes.statusIconColor} height={18} />{' '}
            <span className={classes.statusTextColor}>Continue</span>
          </div>
          // <>  TODO: How is this % complete calculated? (Later phase...)
          //   <PlayCircleOutlineOutlinedIcon className={classes.statusIcon} /> <span className={classes.statusText}>Continue ({status}% Complete)</span>
          // </>
        );
      } else if (status === 'completed') {
        return (
          <div className={classes.alignButtonText}>
            <CheckBoxIcon className={classes.statusIconAndText} /> <span className={classes.statusIconAndText}>Completed</span>
          </div>
        );
      } else if (status === 'notstarted') {
        return (
          <div className={classes.alignButtonText}>
            <PlayCircleOutlineOutlinedIcon className={classes.statusIconAndText} /> <span className={classes.statusIconAndText}>Start</span>
          </div>
        );
      }
    };

    const isPreviousCourseComplete = (course, registered, completed) => {
      const courseIdx = moduleCourseList.findIndex((c) => c.course_id === course.course_id);
      if (courseIdx === 0) {
        return true;
      } else {
        if (moduleCourseList[courseIdx - 1]?.completed) {
          return true;
        } else {
          return false;
        }
      }
    };

    const fetchCourseCompletionStatus = (course, admin) => {
      if (isPreviousCourseComplete(course, course.registered, course.completed)) {
        if (course.completed) {
          return (
            <div className={classes.alignButtonText}>
              <CheckBoxIcon className={classes.statusIconAndText} /> <span className={classes.statusIconAndText}>Completed</span>
            </div>
          );
        } else if (course.registered) {
          return (
            <div className={classes.alignButtonText}>
              <img src={PlayPauseIcon} alt='Continue' className={classes.statusIconColor} />{' '}
              <span className={classes.statusTextColor}>{admin ? 'In Progress' : 'Continue'}</span>
            </div>
          );
        } else {
          return (
            <div className={classes.alignButtonText}>
              <PlayCircleOutlineOutlinedIcon className={classes.statusIconAndText} />{' '}
              <span className={classes.statusIconAndText}>{admin ? 'Not Started' : 'Get Started'}</span>
            </div>
          );
        }
      } else {
        return (
          <div className={classes.alignButtonText}>
            <img src={LockIcon} alt='Locked' className={classes.statusLockedIconColor} /> <span className={classes.statusTextColor}>Locked</span>
          </div>
        );
      }
    };

    const isCourseLocked = (course, admin) => {
      if (isPreviousCourseComplete(course, course.registered, course.completed)) {
        return false;
      } else {
        return true;
      }
    };

    const handleCreateHelpApp = async () => {
      store.setAppCreated(true);
      try {
        store.setLoading(false);
        store.setSearching(true);
        const app = await callApi(auth, 'helprequest', 'POST', {
          item: {
            userId: store.senior.userId,
            created_at: new Date(),
            updated_at: new Date(),
            status: 'created',
            status_date: new Date(),
            status_by: auth.user.result.first_name + ' ' + auth.user.result.last_name,
          },
        });

        if (app.result) {
          store.setHelpAppList([...store.helpAppList, app.result]);
          store.setHelpApp(app.result);
        }
        store.setSearching(false);
        store.setLoading(false);
        openHelpApp(app.result.id);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error creating initial Help request application:', error);
      }
    };

    const fetchHelpApplications = async () => {
      try {
        store.setLoading(true);
        store.setSearching(true);
        let applications = await callApi(auth, 'helprequest/list/' + store.senior.userId, 'GET');
        if (applications.result) store.setHelpAppList(applications.result);
        store.setSearching(false);
        store.setLoading(false);
        setPage('helpapps');
      } catch (err) {
        logException(err);
        store.setLoading(false);
        console.error(err);
      }
    };

    const handleCreateScholarshipApp = async () => {
      store.setAppCreated(true);
      try {
        store.setLoading(false);
        store.setSearching(true);
        const app = await callApi(auth, 'scholarship', 'POST', {
          item: {
            userId: store.senior.userId,
            status: 'created',
            status_date: new Date(),
            status_by: auth.user.result.first_name + ' ' + auth.user.result.last_name,
            applicant_type: isAlumni(auth.roles) ? 'alumni' : 'senior',
          },
        });

        if (app.result) {
          store.setScholarshipList([...store.scholarshipList, app.result]);
          store.setScholarshipApp(app.result);
        }
        store.setSearching(false);
        store.setLoading(false);
        openScholarshipApp(app.result.id);
      } catch (error) {
        logException(error);
        store.setSearching(false);
        store.setLoading(false);
        console.error('Error creating initial scholarship application:', error);
      }
    };

    const fetchScholarshipApplications = async () => {
      try {
        store.setLoading(true);
        store.setSearching(true);
        let applications = await callApi(auth, 'scholarship/list/' + store.senior.userId, 'GET');
        if (applications.result) store.setScholarshipList(applications.result);
        store.setSearching(false);
        store.setLoading(false);
        setPage('scholarshipapps');
      } catch (err) {
        logException(err);
        store.setLoading(false);
        console.error(err);
      }
    };

    const handleCreateRecommendationRequest = async () => {
      store.setNewRecommendation(true);
      setPage('recommendationpage');
    };

    // const fetchRecommendations = async () => {
    //   try {
    //     store.setLoading(true);
    //     store.setSearching(true);
    //     let recommendations = await callApi(auth, 'recommendation/', 'GET');
    //     store.setRecommendationList(recommendations.result);
    //     store.setSearching(false);
    //     store.setLoading(false);
    //     setPage('recommendationlist');
    //   } catch (err) {
    //     logException(err);
    //     store.setLoading(false);
    //     console.error(err);
    //   }
    // };

    const fetchRecommendationsForStudent = async () => {
      try {
        store.setLoading(true);
        store.setSearching(true);
        let recommendations = await callApi(auth, 'recommendation/student/' + store.senior.id, 'GET');
        if (recommendations.result) store.setRecommendationList(recommendations.result);
        store.setSearching(false);
        store.setLoading(false);
        setPage('recommendationlist');
      } catch (err) {
        logException(err);
        store.setLoading(false);
        console.error(err);
      }
    };

    const handleHelpClose = () => {
      setShowHelp(false);
    };

    const handleLifeSkillsClose = () => {
      setShowLifeSkills(false);
    };

    const handleHelp = (event) => {
      event.preventDefault();
      event.stopPropagation();
      setShowHelp(true);
    };

    const countOpenApplications = () => {
      let totalOpen = 0;
      store.aftercareList.forEach((app) => {
        // The next line results in ANY status other than approved or denied as being counted as "open"
        if (app.status !== 'approved' && app.status !== 'denied') {
          totalOpen += 1;
        }
      });
      return totalOpen;
    };

    const navToAftercareApps = () => {
      if (store.senior.userId) {
        fetchAftercareApplications();
      }
    };

    const navToScholarshipApps = () => {
      if (store.senior.userId) {
        fetchScholarshipApplications();
      }
    };

    const navToWorkbook = async () => {
      if (store.senior.userId) {
        await fetchWorkbookModules({
          auth,
          userId: store.senior.userId,
          setWorkbookModuleList,
          setPage,
          store,
          logException,
          callApi,
        });
      }
    };

    const navToRecommendations = () => {
      if (store && store.senior && store.senior.userId) {
        fetchRecommendationsForStudent();
      }
    };

    const navToCheckInApps = () => {
      if (store && store.senior && store.senior.userId) {
        store.setCheckInId(store.senior.id);
        history.push('/contactlist');
      }
    };

    const navToHelpApps = () => {
      if (store.senior.userId) {
        fetchHelpApplications();
      }
    };

    const navToLifeSkillsSchedule = async () => {
      setPage('life');
    };

    const reloadWorkbookInfo = async () => {
      try {
        if (!store.senior?.userId) return;
        store.setLoading(true);

        const workbookModules = await callApi(auth, PATH.SENIOR_PLAN_DETAILS(store.senior.userId), METHOD.GET, null, CONTENT_TYPE.APPLICATION_JSON);

        const modules = Array.isArray(workbookModules.result)
          ? workbookModules.result.flatMap((w) => (Array.isArray(w.modules) ? w.modules : []))
          : [];

        const currentModule = modules.find((m) => m.id === workbookModuleId);

        const coursesToDisplay = currentModule?.steps?.flatMap((step) => (Array.isArray(step.courses) ? step.courses : [])) || [];

        setWorkbookModuleList(modules);
        setWorkbookModule(currentModule ? { ...workbookModule, ...currentModule } : workbookModule);
        setModuleCourseList(coursesToDisplay);
      } catch (err) {
        logException(err);
        console.error(err);
      } finally {
        store.setLoading(false);
      }
    };

    const navToAwardPaymentRequests = () => {
      if (store && store.senior && store.senior.userId) {
        history.push(PATH.AWARD_PAYMENT_REQUESTS);
      }
    };

    return (
      <div className={classes.plannerContainer}>
        <PleaseWait isLoading={store.loading} />
        {page === 'home' && (
          <Home
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            formatPhoneNumber={formatPhoneNumber}
            showReturnedAftercareApp={showReturnedAftercareApp}
            showReturnedScholarshipApp={showReturnedScholarshipApp}
            aftercareSpecialist={aftercareSpecialist}
            showReturnedChecklist={showReturnedChecklist}
            showReturnedPlanningForm1={showReturnedPlanningForm1}
            showReturnedPlanningForm2={showReturnedPlanningForm2}
            setPage={setPage}
            navToHelpApps={navToHelpApps}
            navToAftercareApps={navToAftercareApps}
            navToScholarshipApps={navToScholarshipApps}
            navToRecommendations={navToRecommendations}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            navToCheckInApps={navToCheckInApps}
            navToWorkbook={navToWorkbook}
            switches={featureSwitches}
            workbookModuleList={workbookModuleList}
            fetchButtonCompletionStatus={fetchButtonCompletionStatus}
            handleSetButtonColorByStatus={handleSetButtonColorByStatus}
            setShowLifeSkills={setShowLifeSkills}
            userId={auth?.user?.result?.id}
            isFHTMode={!!isFHT(auth.roles)}
            navToAwardPaymentRequests={navToAwardPaymentRequests}
          />
        )}
        {page === 'helpapps' && (
          <HelpApps
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            aftercareSpecialist={aftercareSpecialist}
            formatPhoneNumber={formatPhoneNumber}
            helpAppList={store.helpAppList}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            handleCreateHelpApp={handleCreateHelpApp}
            openHelpApp={openHelpApp}
            summarizeHelpOptions={summarizeHelpOptions}
            displayStatus={displayStatus}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'aftercareapps' && (
          <AftercareApps
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            aftercareSpecialist={aftercareSpecialist}
            aftercareList={store.aftercareList}
            countOpenApplications={countOpenApplications}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            showReturnedAftercareApp={showReturnedAftercareApp}
            displayStatus={displayStatus}
            formatPhoneNumber={formatPhoneNumber}
            handleCreateAftercareApp={handleCreateAftercareApp}
            openAftercareApp={openAftercareApp}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'scholarshipapps' && (
          <ScholarshipApps
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            aftercareSpecialist={aftercareSpecialist}
            formatPhoneNumber={formatPhoneNumber}
            handleCreateScholarshipApp={handleCreateScholarshipApp}
            showReturnedScholarshipApp={showReturnedScholarshipApp}
            scholarshipList={store.scholarshipList}
            openScholarshipApp={openScholarshipApp}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            displayStatus={displayStatus}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {/* {page === 'recommendationlist' && (isStudent(auth.roles) || isAlumni(auth.roles)) && ( */}
        {page === 'recommendationlist' && (
          <Recommendations
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            formatPhoneNumber={formatPhoneNumber}
            recommendationList={store.recommendationList}
            handleCreateRecommendationRequest={handleCreateRecommendationRequest}
            openRecommendation={openRecommendation}
            displayStatus={displayStatus}
            aftercareSpecialist={aftercareSpecialist}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'basicinfo' && (
          <BasicInfo
            alumni={store.alumni}
            roles={auth.roles}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {(store.alumni || isAlumni(auth.roles)) && page === 'helpapp' && (
          <HelpApp
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'planning1' && (
          <Planning1
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'planning2' && (
          <Planning2
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'checklist' && (
          <SeniorChecklist
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'aftercareapp' && (
          <Aftercare
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'scholarshipapp' && (
          <Scholarship
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            classes={classes}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'recommendationpage' && (
          <Recommendation
            senior={store.senior}
            alumni={store.alumni}
            roles={auth.roles}
            handleHelp={handleHelp}
            store={store}
            auth={auth}
            handleAfterSaveReturn={handleAfterSaveReturn}
            setPage={setPage}
            handleReturnToSeniorList={handleReturnToSeniorList}
            fetchRecommendations={fetchRecommendationsForStudent}
            classes={classes}
            handleAfterAboutMeUpdate={handleAfterAboutMeUpdate}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
          />
        )}
        {page === 'workbook' && (
          <Workbook
            workbookModuleList={workbookModuleList}
            allResources={allResources}
            openWorkbookModule={openWorkbookModule}
            setPage={setPage}
            classes={classes}
            fetchButtonCompletionStatus={fetchButtonCompletionStatus}
            handleSetButtonColorByStatus={handleSetButtonColorByStatus}
            roles={auth.roles}
            senior={store.senior}
            alumni={store.alumni}
            handleReturnToSeniorList={handleReturnToSeniorList}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
            refreshWorkbookStatus={reloadWorkbookInfo}
            isStaffMode={false}
            isFHTMode={isFHT(auth.roles) ? true : false}
          />
        )}
        {page === 'workbookmodule' && (
          <WorkbookModule
            moduleCourseList={moduleCourseList}
            workbookModule={workbookModule}
            workbookModuleNumber={workbookModuleNumber}
            allResources={allResources.filter((s) => s.module_id === workbookModule.id)}
            fetchCourseCompletionStatus={fetchCourseCompletionStatus}
            setPage={setPage}
            classes={classes}
            roles={auth.roles}
            fetchWorkbook={reloadWorkbookInfo}
            senior={store.senior}
            alumni={store.alumni}
            handleReturnToSeniorList={handleReturnToSeniorList}
            handleGotoAdminHomepage={handleGotoAdminHomepage}
            handleSetButtonColorByRegisteredCompletion={handleSetButtonColorByRegisteredCompletion}
            isCourseLocked={isCourseLocked}
            isStaffMode={false}
            isFHTMode={isFHT(auth.roles) ? true : false}
          />
        )}
        {/* {!isAlumni(auth.roles) && page === 'tips' && <Tips setPage={setPage} classes={classes} />} */}
        {!isAlumni(auth.roles) && page === 'life' && (
          <div style={{ border: '2px solid red', height: '130px' }}>
            <Life setPage={setPage} classes={classes} />
          </div>
        )}
        <HelpDialog
          title='Printer Tips & Tricks'
          content={
            <React.Fragment>
              <Grid container direction='row' style={{ marginBottom: 15 }}>
                <Grid item xs={12}>
                  When the print menu opens, choose the destination (such as a specific printer or PDF file) on the top right side of the window.
                </Grid>
              </Grid>
              <Grid container direction='row' style={{ marginBottom: 15 }}>
                <Grid item xs={12}>
                  To improve the look of your printed copies, click on "More settings" on the right side and change the "Margins" setting to "Minimum"
                  or "Custom." This will add a margin around the contents, so the page break doesn't happen in the middle of a line.
                </Grid>
              </Grid>
            </React.Fragment>
          }
          showHelp={showHelp}
          handleClose={handleHelpClose}
        />
        <LifeSkillsDialog showLifeSkills={showLifeSkills} handleClose={handleLifeSkillsClose} />
        {page === 'home' && (isStudent(auth.roles) || isAlumni(auth.roles)) && store.senior && (
          <footer className={classes.footerContact} style={{ width: '100%', marginTop: '100px' }}>
            <Grid container className={classes.footerMargin}>
              <Grid item xs={false} md={2} lg={2} />
              <Grid item xs={12} md={4} lg={4}>
                <a href='/home'>
                  <img src={BoysTownLogo} alt='Boys Town' style={{ width: '50%' }} />
                </a>
                <div className={classes.footerContact}>
                  <div className={classes.footerContactInfo}>
                    <div>&copy; {year} Boys Town. All Rights Reserved.</div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={false} md={1} lg={1} />
              <Grid item xs={12} md={3} lg={3} align='left'>
                <div className={classes.footerTitle}>CONTACT US</div>
                <div className={classes.footerContactInfo}>
                  <div>
                    <a href='mailto:successfulfutures@boystown.org'>SuccessfulFutures@Boystown.org</a>
                  </div>
                  <div>531-355-3060</div>
                </div>
                <div className={classes.version}></div>
              </Grid>
              <Grid item xs={false} md={2} lg={2} />
            </Grid>
          </footer>
        )}
        <Snackbar
          ContentProps={{
            classes: {
              root: classes.warning,
            },
          }}
          open={showWarning}
          autoHideDuration={6000}
          onClose={handleClose}
          message={warning}
          action={action}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        ></Snackbar>
      </div>
    );
  })
);

export default SeniorPlanner;
